import { baseURL } from "../Config";
import axios from "axios";
import { toast } from "react-toastify";

export const handleGetRequest = async (url, params = {}) => {
  if (!navigator.onLine) {
    // Handle the case when the network is off
    toast.error(
      "No internet connection. Please check your network and try again."
    );
    return;
  }
  try {
    const response = await axios.get(`${baseURL + url}`, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      params, // Pass the additional params for pagination
    });
    return response.data;
  } catch (error) {
    const id = toast.loading("Please wait...");
    if (error?.response?.status === 500)
      toast.update(id, {
        render: error?.response?.data?.messages || "Something went wrong !!",
        type: "error",
        isLoading: false,
        autoClose: 1000,
      });
    else
      toast.update(id, {
        render: error?.response?.data?.messages || "Something went wrong !!",
        type: "warn",
        isLoading: false,
        autoClose: 1000,
      });
  }
};
